import { FC, useState } from 'react';
import dayjs from 'dayjs';
import { TableBody as Body } from '@mui/material';

import { CustomTableRow, RowTableCell } from '../../shared/uiComponents/Table/tableHelpers';
import { CustomAlert, CustomButton, CustomTable } from '../../shared/uiComponents';
import { AuthorizationDetailsCard } from './MobileView/authorizationCard';

import {
	AuthorizationDetailsProperties,
	DashboardAuthorizationProperties,
} from '../../redux/API/ClientAPIHelpers/userClientProperties';

interface RowRendererProperties {
	data: AuthorizationDetailsProperties[];
}
const headers = [
	{ id: '1', name: 'Authorization period' },
	{ id: '2', name: 'CPT code' },
	{ id: '3', name: 'Frequency type' },
	{ id: '4', name: 'Allocated' },
	{ id: '5', name: 'Used' },
	{ id: '6', name: 'Remaining' },
];

const TableBody: FC<RowRendererProperties> = ({ data }) => (
	<Body>
		{data.map((row) =>
			row.authorizationDetails.map((item, index) => (
				<CustomTableRow key={index}>
					{index === 0 ? (
						<RowTableCell>
							{`${dayjs(row.startDate).format('MM/DD/YYYY')} - ${dayjs(row.endDate).format('MM/DD/YYYY')}`}
						</RowTableCell>
					) : (
						<RowTableCell />
					)}
					<RowTableCell>{item.sessionType.name}</RowTableCell>
					<RowTableCell>{item.frequency.name}</RowTableCell>
					<RowTableCell>{item.totalHours}</RowTableCell>
					<RowTableCell>{item.hoursUsed}</RowTableCell>
					<RowTableCell>{item.hoursRemaining}</RowTableCell>
				</CustomTableRow>
			)),
		)}
	</Body>
);

const MobileView = ({ items }: { items: AuthorizationDetailsProperties[] }) => (
	<div className="authorizationDetailsWrapper">
		{items.map((auth) => (
			<AuthorizationDetailsCard item={auth} key={`${auth.id}-card`} />
		))}
	</div>
);

const AuthorizationMoreInfoContent = ({ info }: { info: DashboardAuthorizationProperties }) => (
	<div style={{ width: '100%' }}>
		<CustomTable
			headers={headers}
			data={{ query: info.authorizations }}
			loading={false}
			TableBody={TableBody}
			hasPagination={false}
		/>
		<MobileView items={info.authorizations} />
	</div>
);

const AuthorizationDetailedInfo = ({ info }: { info: DashboardAuthorizationProperties }) => {
	const [open, setOpen] = useState<boolean>(false);

	return (
		<>
			<CustomButton buttonType="secondaryGray" title="Details" onClick={() => setOpen(true)} />
			<CustomAlert
				open={open}
				onClose={() => setOpen(false)}
				title={info.client.fullName}
				maxWidth="md"
				Content={() => <AuthorizationMoreInfoContent info={info} />}
			/>
		</>
	);
};

export default AuthorizationDetailedInfo;
